<template>
  <div class="bbp-files-drop" :class="{'bbp-files-drop_long': files.length > 0}">
    <VuePerfectScrollbar class="bbp-files-drop-list" v-if="files.length > 0">
      <div class="bbp-files-drop-list-item" v-for="(file, index) in files" :key="file.name + index">
        <i class="bbp-files-drop-list-item__icon bbp-icon-document"/>
        <span class="bbp-files-drop-list-item__name">{{file.name}}</span>
        <span class="bbp-files-drop-list-item__size" v-if="file.size">{{getFileSize(file.size)}}</span>
        <i class="bbp-files-drop-list-item__close bbp-icon-cross" @click.stop="removeFile($event, index)"/>
      </div>
    </VuePerfectScrollbar>
    <div class="bbp-files-drop-input"
         ref="bbpFilesContainer"
         :class="{'bbp-files-drop-input_short': files.length > 0}">
      <div class="bbp-files-drop-text">
        <span>Drag & drop or</span>
        <div class="bbp-files-drop-text-select">
          <span>browse</span>
        </div>
        <input class="bbp-files-drop-text-select__input"
               id="bbpFilesProject"
               title=''
               type="file"
               multiple
               @change="getFiles">
      </div>
    </div>
  </div>
</template>

<script>
import {get, concat} from 'lodash'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import getFileSize from '@/mixin/getFileSize'

export default {
  name: 'BBPFilesDrop',
  props: ['input', 'model'],
  components: {VuePerfectScrollbar},
  mixins: [getFileSize],
  data () {
    return {
      files: []
    }
  },
  methods: {
    removeFile (e, index) {
      this.files.splice(index, 1)
      e.preventDefault()
      this.$emit('input', this.files)
    },
    getFiles (e) {
      const files = Array.from(e.target.files)
      e.target.value = ''
      this.setFiles(files)
    },
    setFiles (files) {
      this.files = concat(this.files, [...files])
      this.$emit('input', this.files)
    },
    setDefaultFiles () {
      const selectedFiles = get(this.model, this.input.model, [])
      this.files = selectedFiles
    },
    setPreventDefaultEvents () {
      const container = get(this.$refs, 'bbpFilesContainer')
      if (!container) return
      const eventsHighlight = ['dragenter', 'dragover']
      const eventsUnHighlight = ['dragleave', 'drop']
      const events = ['drag', 'dragstart', 'dragend', ...eventsHighlight, ...eventsUnHighlight]
      events.forEach(event => {
        container.addEventListener(event, e => {
          const className = 'bbp-files-drop-input_highlight'
          if (eventsHighlight.includes(event)) container.classList.add(className)
          if (eventsUnHighlight.includes(event)) container.classList.remove(className)
          e.preventDefault()
          e.stopPropagation()
        }, false)
      })
      container.addEventListener('drop', e => {
        const files = get(e, 'dataTransfer.files', [])
        this.setFiles(files)
      })
    }
  },
  beforeMount () {
    this.setDefaultFiles()
  },
  mounted () {
    this.setPreventDefaultEvents()
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";

  .bbp-files-drop {
    @include global-font;
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: space-between;
    position: relative;
    height: 96px;
    min-height: 96px;
    width: 100%;
    font-weight: 600;
    font-size: 12px;
    line-height: 14px;

    &_long {
      border: 1px solid $color-mercury;
      border-radius: 5px;
      padding: 10px 10px;
      height: auto;
    }

    &-input {
      width: 100%;
      height: 96px;
      display: flex;
      background: $color-link-water;
      border: 1px dashed $color-accent;
      box-sizing: border-box;
      border-radius: 5px;
      transition: 0.3s;
      cursor: pointer;

      &_short {
        height: 35px;
      }

      &_highlight,
      &:hover {
        opacity: 0.8;
        border-color: $color-accent-hover;
        background: rgba($color-link-water, 0.8)
      }
    }

    &-text {
      width: 100%;
      height: 100%;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      color: $color-silver;

      &-select {
        color: $color-accent;
        text-decoration: underline;
        margin-left: 3px;
        transition: 0.3s;

        &:hover {
          color: $color-accent-hover;
        }

        &__input {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          opacity: 0;
          cursor: pointer;
          padding: 0 45px;
          z-index: 5;
        }
      }
    }

    &-list {
      display: grid;
      grid-gap: 12px;
      width: 100%;
      margin-bottom: 10px;
      z-index: 6;

      &-item {
        position: relative;
        display: grid;
        grid-template-columns: 31px auto;
        grid-gap: 3px 8px;
        font-size: 11px;
        line-height: 13px;

        &__icon {
          grid-row: 1/3;
          width: 31px;
          height: 31px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: $color-accent;
          background-color: $color-link-water;
          font-size: 18px;
          border-radius: 6px;
        }

        &__name {
          max-width: 242px;
          overflow: hidden;
          text-overflow: ellipsis;
          color: $color-black;
          font-weight: 500;
        }

        &__size {
          color: $color-silver;
          font-weight: normal;
        }

        &__close {
          position: absolute;
          top: 5px;
          right: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          width: 21px;
          height: 21px;
          color: $color-silver;
          transition: 0.3s;
          cursor: pointer;

          &:hover {
            color: $color-dusty-gray;
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/BBPForm/BBPFilesDrop/BBPFilesDrop.vue